export enum ECheckEstimationExistsActions {
  CHECK_ESTIMATION_EXISTS_REQUEST = 'checkEstimationExistsRequest',
  CHECK_ESTIMATION_EXISTS_ERROR = 'checkEstimationExistsError',
  RESET_CHECK_ESTIMATION_EXISTS = 'resetCheckEstimationExists',
  SET_ESTIMATION_READY = 'setEstimationReady',
}
